import { z } from "zod";

export const sharePreviewSubjectSchema = z.discriminatedUnion("kind", [
    z.strictObject({ kind: z.literal("listing"), id: z.string().min(1) }),
    z.strictObject({ kind: z.literal("organization"), id: z.string().min(1) }),
]);
export type SharePreviewSubject = z.infer<typeof sharePreviewSubjectSchema>;

export const sharePreviewCardSchema = z.strictObject({
    headline: z.string().min(1),
    subline: z.string(),
    photoUrls: z.array(z.url()).max(8),
});
export type SharePreviewCard = z.infer<typeof sharePreviewCardSchema>;

export const sharePreviewMediaSchema = z.strictObject({
    imageUrl: z.url(),
    videoUrl: z.url(),
});
export type SharePreviewMedia = z.infer<typeof sharePreviewMediaSchema>;

export const SHARE_PREVIEW_WIDTH = 1200;
export const SHARE_PREVIEW_HEIGHT = 630;
